import { Card, Divider, Typography } from '@mui/material';

import WordCloud from 'react-d3-cloud';
import { scaleOrdinal } from 'd3-scale';
import { schemeCategory10 } from 'd3-scale-chromatic';
import { Box } from '@mui/system';

const data = [
    { text: 'Variation', value: 2 },
    { text: 'Volume', value: 20 },
    { text: 'Taste', value: 80 },
    { text: 'postion size', value: 100 },
    { text: 'food tempature', value: 10 },
];

const schemeCategory10ScaleOrdinal = scaleOrdinal(schemeCategory10);



export function SatisfactionResponsesWordCloud() {
    return (
        <Box sx={{ display: "flex", marginTop: "5rem" }}>
            <Card sx={{ width: "100%", marginRight: "2rem" }} elevation={8}>
                <Typography variant="h6" sx={{ paddingTop: "0.5rem", paddingBottom: "0.25rem", marginLeft: '1rem' }}>
                    Satisfied with
                </Typography>
                <Divider sx={{ marginX: '1rem' }} />

                <WordCloud
                    data={data}
                    width={150}
                    height={50}
                    fontSize={(word) => Math.log2(word.value) * 2}
                    spiral="archimedean"
                    padding={5}
                    rotate={0}
                    random={Math.random}
                    onWordClick={(event, d) => {
                        console.log(`onWordClick: ${d.text}`);
                    }}
                    onWordMouseOver={(event, d) => {
                        console.log(`onWordMouseOver: ${d.text}`);
                    }}
                    onWordMouseOut={(event, d) => {
                        console.log(`onWordMouseOut: ${d.text}`);
                    }}
                />
            </Card>

            <Card sx={{ width: "100%" }} elevation={8}>
                <Typography variant="h6" sx={{ paddingTop: "0.5rem", paddingBottom: "0.25rem", marginLeft: '1rem' }}>
                    Desatisfied with
                </Typography>
                <Divider sx={{ marginX: '1rem' }} />
                <WordCloud
                    data={data}
                    width={150}
                    height={50}
                    fontSize={(word) => Math.log2(word.value) * 2}
                    spiral="rectangular"
                    padding={5}
                    rotate={0}
                    random={Math.random}
                    onWordClick={(event, d) => {
                        console.log(`onWordClick: ${d.text}`);
                    }}
                    onWordMouseOver={(event, d) => {
                        console.log(`onWordMouseOver: ${d.text}`);
                    }}
                    onWordMouseOut={(event, d) => {
                        console.log(`onWordMouseOut: ${d.text}`);
                    }}
                />
            </Card>
        </Box>
    )
}
